import Stop from "./stop";

let $printWrapper,
	templateMain,
	templateSchedule;

const Print = {
	init: async () => {
		const $printButton = document.getElementById( 'tm__btn-print-timetable' );
		$printWrapper = document.getElementById( 'tm__print' );

		// get the main templateMain with the schedule templateMain pulled out as a separate templateMain
		templateSchedule = $printWrapper.querySelector( '.tm__print-schedule' ).outerHTML;
		$printWrapper.querySelector( '.tm__print-schedule' ).remove();
		templateMain = $printWrapper.innerHTML;

		$printButton.addEventListener( 'click', Print.printTimetable );
	},

	printTimetable: () => {
		const visible = TransitMap.getProperty( 'visible' );
		const documentTitle = document.title;

		$printWrapper.innerHTML = Print.renderTimetable( visible );
		document.title = 'Timetable for ' + visible.agencyName + ': ' + visible.routeName;
		window.print();
		document.title = documentTitle;
	},

	renderTimetable: ( visible ) => {
		let output = templateMain.replace( "{{ agency }}", visible.agencyName ? visible.agencyName : '' );
		output = output.replace( "{{ route }}", visible.routeName ? visible.routeName : '' );
		output = output.replace( "{{ stop }}", visible.stopName ? visible.stopName : '' );
		output = output.replace( "{{ schedules }}", Print.renderSchedules() );
		return output;
	},

	renderSchedules: () => {
		const $dropdownDestination = document.getElementById( 'tm__destination' );
		let output = '';
		for ( const destination of $dropdownDestination.options ) {
			let schedule = templateSchedule.replace( '{{ destination }}', destination.text );
			schedule = schedule.replace( '</table>', '<tr>' + Print.renderDestination( destination ) + '</tr></table>' );
			output += schedule;
		}
		return output;
	},

	renderDestination: ( destination ) => {
		let timetable = '';
		for ( const day of ['mo', 'tu', 'we', 'th', 'fr', 'sa', 'su'] ) {
			timetable += '<td><ul>' + Print.renderDay( destination, day ) + '</ul></td>';
		}
		return timetable;
	},

	renderDay: ( destination, day ) => {
		const $stopPanelTimes = document.getElementById( 'tm__stop' ).querySelector( '.tm__stop-times' ).querySelector( 'ul' ),
			$times = $stopPanelTimes.cloneNode( true ),
			$noArrivals = $times.querySelector( '.tm__no-arrivals' );
		Stop.filterArrivals( $times, $noArrivals, destination.value, day );
		return $times.innerHTML;
	}
}

export default Print;
